<mat-card [routerLink]="['/jobViewer', job().jobId]" (click)="saveActiveJob(job().jobId)">
  <mat-card-content>
    <div
      class="job-card"
      [ngClass]="{ 'unread-job bg-alice-blue': job()?.unread, 'active-job': job().jobId === activeJobId() }">
      <div class="left-block">
        <div class="timestamp body-2">
          @if (hasRedBadge()) {
            <mat-icon class="ellipse text-red!" inline="true">lens </mat-icon>
          }
          @if (job()?.unsubmittedDocument || job()?.unreadDiary) {
            @if (job()?.unreadDiary) {
              <mat-icon class="mat-icon-comment text-red!" inline="true">comment_24px</mat-icon>
            }
            @if (job()?.unsubmittedDocument) {
              <mat-icon class="text-red!" inline="true">send</mat-icon>
            }
          }
        </div>
        @if (job().inspectionDate && (bucket() === 'REQUEST_FOR_QUOTE' || bucket() === 'PENDING_ASSESSMENT')) {
          <div class="body-2 display-ellipsis">Inspection scheduled: {{ job().inspectionDate | date: 'd/M/yy' }}</div>
        }
        <div class="claim-nb display-ellipsis subtitle-1 flex items-center" [ngClass]="{ 'font-bold': job()?.unread }">
          @if (job()?.unread) {
            <mat-icon class="size-20! text-14! material-icons-outlined bg-dodger-blue text-white! rounded p-[3px] mr-5">
              mark_email_unread_outline
            </mat-icon>
          }
          {{ job().claimNumber }}
        </div>
        <div class="body-2 display-ellipsis">
          {{ job().insco }}
        </div>
        @if (job()?.ownerCompanyName || job()?.ownerPersonName) {
          <div class="owner">
            <mat-icon>account_circle</mat-icon>
            <span class="body-2">{{
              job().ownerIsACompany ? job()?.ownerCompanyName || '' : job()?.ownerPersonName || ''
            }}</span>
          </div>
        }
        <div
          class="display-ellipsis body-2"
          [class.scrolling-text]="job()?.vehicleDescription && setAnimation()"
          #vehicleDescription>
          <span class="full-vehicle" #vehicleDescriptionText>{{ job().vehicleDescription }}</span>
        </div>
      </div>

      <car-placeholder-or-photo
        repairerTile
        [rego]="job()?.rego"
        [preSignedUrl]="job()?.photoIdentityUI?.preSignedUrl" />

      <div class="kebab-block">
        <button matIconButton [matMenuTriggerFor]="kebabMenu" (click)="$event.stopPropagation()">
          <mat-icon>more_vert_32px</mat-icon>
        </button>
      </div>
    </div>
    @if (job().totalLoss) {
      <div
        class="body-3 font-semibold p-5 absolute bottom-0 left-0 rounded-tr-[4px] rounded-bl-[4px] bg-orange flex justify-center items-center gap-5">
        <mat-icon class="size-15!" svgIcon="total_loss_icon" />
        <div class="flex items-end h-15">TOTAL LOSS</div>
      </div>
    }
    @if (job()?.invoicedAndCostControlledExternally) {
      <div class="body-3 font-semibold p-5 absolute bottom-0 left-0 rounded-tr-[4px] rounded-bl-[4px] bg-[#72ca97]">
        INVOICED EXTERNALLY
      </div>
    }
    @if (job()?.authorityDate !== '' && ['AUTHORIZED', 'PRE_AUTHORIZED'].includes(bucket())) {
      <div
        class="status body-2"
        (click)="!userService.isRepairerSiteSuspended() && openRepairTimelineModal(job()); $event.stopPropagation()"
        [ngClass]="{ 'pointer-events-none bg-charcoal-90! text-neut-60!': userService.isRepairerSiteSuspended() }">
        <div>BOOK REPAIRS</div>
        <button
          matButton="filled"
          class="red-button size-[27px]! min-w-[27px]! p-0!"
          type="button"
          [ngClass]="{ 'bg-light-pink!': userService.isRepairerSiteSuspended() }">
          <mat-icon class="m-0!">exit_to_app</mat-icon>
        </button>
      </div>
    }
  </mat-card-content>
</mat-card>

<mat-menu #kebabMenu="matMenu" [xPosition]="'before'" class="job-progress">
  <ng-template matMenuContent>
    <button (click)="archiveJob(job()?.jobId)" mat-menu-item>Archive job</button>
    <button (click)="toggleJobReadStatus(job()?.unread, job()?.jobId)" mat-menu-item>
      Mark as {{ job()?.unread ? 'read' : 'unread' }}
    </button>
  </ng-template>
</mat-menu>
